import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import type ILicense from '@/components/interfaces/License';
import SPASectionHeading from '../../shared/SPASectionHeading';
import { useSPAToast } from '../../shared/SPAToast';
import { PanelFooter, panelClass } from '../../shared/formPanel';
import { informationPayload, toFormValues } from './programForm';
import type { ProgramFormValues } from './programForm';
import ProgramInformationFields from './ProgramInformationFields';
import { EditableProgram, useUpdateProgram } from './useProgram';

interface ProgramInformationPanelProps {
  licenses: ILicense[];
  program: EditableProgram;
}

const ProgramInformationPanel = ({ licenses, program }: ProgramInformationPanelProps) => {
  const spaToast = useSPAToast();
  const updateProgram = useUpdateProgram(program.id);
  const values = useMemo(() => toFormValues(program), [program]);
  const form = useForm<ProgramFormValues>({ values });

  const save = (formValues: ProgramFormValues) => {
    updateProgram.mutate(informationPayload(formValues), {
      onSuccess: () => spaToast.success('Saved program information.'),
    });
  };

  return (
    <form noValidate className={panelClass} onSubmit={form.handleSubmit(save)}>
      <SPASectionHeading className="tw-mb-5" title="Program Information" />
      <ProgramInformationFields form={form} licenses={licenses} />
      <PanelFooter update={updateProgram} />
    </form>
  );
};

export default ProgramInformationPanel;
